import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  ArrowRight,
  BadgeCheck,
  Boxes,
  FileText,
  Info,
  IndianRupee,
  LoaderCircle,
  LocateFixed,
  MapPin,
  MessageCircleMore,
  Package,
  PillBottle,
  ShoppingCart,
  ShieldCheck,
  User,
  X,
  Zap,
  Clock,
  CalendarDays,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import NearbyPlacesAutocomplete from "../components/NearbyPlacesAutocomplete";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Signin from "../components/Signin";
import Signup from "../components/Register";
import OTPVerification from "../components/OTP";
import ServiceabilityModal from "../components/ServiceabilityModal";
import API_URL from "../config/config";
import { toast } from "react-toastify";
import { checkTokenAndNavigate, verifyToken } from "../utils/tokenValidation";
import {
  clearSessionData,
  formatCurrency,
  syncSessionUser,
} from "../utils/sessionUser";
import { saveBookingDraft } from "../utils/bookingDraft";
import { getPreciseCurrentLocation } from "../utils/getPreciseCurrentLocation";
import { checkAddressServiceability } from "../utils/addressServiceability";
import {
  getBestGeocodeResult,
  getCurrentLocationAddressFromGeocodeResults,
} from "../utils/addressFormatting";
import { getAddressText } from "../utils/addressText";

const carouselSlides = [
  // {
  //   // Navratri festive carousel slide.
  //   image: "/assets/festive/Navratri_desktop.png",
  //   mobileImage: "/assets/festive/Navratri_mobile.png",

  //   // Keeps the main Navratri artwork/rider positioned nicely.
  //   position: "center 18%",

  //   eyebrow: "Happy Navratri",

  //   title: "Celebrate Navratri With Fast & Reliable Deliveries",

  //   highlight: "Fast & Reliable Deliveries",

  //   description:
  //     "This Navratri, send gifts, festive essentials, parcels, documents and business orders across the city with fast, secure and reliable delivery service.",

  //   badges: [
  //     "Fast city-wide delivery",
  //     "Safe & Secure",
  //     "Affordable pricing",
  //     "Live tracking",
  //   ],
  // },


    {
      // Desktop image
      image: "/assets/carousel_slider_images/c2 (2).png",

      // Mobile image
      mobileImage: "/assets/mobile_img/c2_mobile.png",

      // Desktop image position
      position: "center 16%",

      // Mobile image position
      mobilePosition: "center center",

      eyebrow: "Doorstep Convenience",

      title: "Deliver essentials and parcels right on time",

      highlight: "right on time",

      description:
        "From documents to household packages, get dependable pickup and doorstep handoff with verified riders.",

      badges: [
        "Doorstep handoff",
        "Trusted riders",
        "COD available",
        "Instant support",
      ],
    },

    {
      // Desktop image
      image: "/assets/carousel_slider_images/c3.png",

      // Mobile image
      mobileImage: "/assets/mobile_img/c3_mobile.png",

      // Desktop image position
      position: "center 14%",

      // Mobile image position
      mobilePosition: "center center",

      eyebrow: "Business Ready",

      title: "Scalable logistics for shops, offices and sellers",

      highlight: "shops, offices and sellers",

      description:
        "Schedule repeated pickups, move inventory faster and keep your customers updated with every delivery.",

      badges: [
        "Bulk parcels",
        "Office logistics",
        "Fast dispatch",
        "Priority support",
      ],
    },
    {
    // NEW DELIVERY TYPES SLIDE

    // Desktop background image
    image: "/assets/carousel_slider_images/c7.png",

    // Agar mobile image bhi add ki hai to uncomment karo
    mobileImage: "/assets/mobile_img/c7_mobile.png",

    position: "center center",
    mobilePosition: "center center",

    eyebrow: "Delivery Options",

    title: "Choose the delivery that fits your schedule",

    highlight: "fits your schedule",

    description:
      "From urgent deliveries to planned bookings, choose Express, Flexible or Scheduled Delivery based on when you need it.",

    badges: [
      {
        label: "Express Delivery",
        icon: Zap,
      },
      {
        label: "Flexible Delivery",
        icon: Clock,
      },
      {
        label: "Scheduled Delivery",
        icon: CalendarDays,
      },
      {
        label: "Across Mumbai",
        icon: MapPin,
      },
    ],

    // Dark overlay on left so text remains clearly readable
    overlayClassName:
      "bg-[linear-gradient(90deg,rgba(2,8,23,0.94)_0%,rgba(2,8,23,0.82)_30%,rgba(2,8,23,0.48)_53%,rgba(2,8,23,0.16)_72%,rgba(2,8,23,0.04)_100%)]",

    // Slightly wider content like generated design
    contentClassName:
      "max-w-[680px] pt-4 text-white lg:pl-10",

    titleClassName:
      "mt-5 text-4xl font-extrabold leading-[1.08] sm:text-5xl lg:text-[58px]",

    descriptionClassName:
      "mt-5 max-w-[610px] text-base leading-7 text-white/90 sm:text-lg",

    // 2 x 2 delivery option layout
    badgesContainerClassName:
      "mt-7 grid max-w-[620px] grid-cols-2 gap-3",

    badgeClassName:
      "inline-flex min-h-[58px] items-center gap-3 rounded-2xl border border-white/25 bg-black/30 px-3 py-3 text-xs font-semibold text-white backdrop-blur-md sm:px-4 sm:text-sm",
  },

    {
      // Desktop image
      image: "/assets/carousel_slider_images/c4.png",

      // Mobile image
      mobileImage: "/assets/mobile_img/c4_mobile.png",

      // Desktop image position
      position: "center top",

      // Mobile image position
      mobilePosition: "center center",

      eyebrow: "Medicine Delivery",

      title: "Reliable pharmacy and healthcare deliveries across the city",

      highlight: "healthcare deliveries",

      description:
        "Sensitive packages, medicine pickups and urgent orders handled with speed, care and secure tracking.",

      badges: [
        "Medicine pickup",
        "Quick dispatch",
        "Secure handling",
        "Tracked delivery",
      ],
    },

    {
      // Desktop image
      image: "/assets/carousel_slider_images/c5.png",

      // Mobile image
      mobileImage: "/assets/mobile_img/c5_mobile.png",

      // Desktop image position
      position: "center 18%",

      // Mobile image position
      mobilePosition: "center center",

      eyebrow: "Across Mumbai",

      title: "Ride ahead with city-wide delivery you can trust",

      highlight: "city-wide delivery",

      description:
        "Smart route coverage, dependable riders and better service for customers, restaurants and businesses.",

      badges: [
        "Wide coverage",
        "Smart routing",
        "Business support",
        "WhatsApp help",
      ],
    },
];

const serviceCards = [
  {
    title: "Parcels",
    description: "Safe pickup and delivery of your parcels.",
    icon: Package,
  },
  {
    title: "Documents",
    description: "Fast and secure delivery of important documents.",
    icon: FileText,
  },
  {
    title: "Food",
    description: "Quick delivery from restaurants and cafes.",
    icon: ShoppingCart,
  },
  {
    title: "Medicines",
    description: "Safe and reliable medicine delivery.",
    icon: PillBottle,
  },
  {
    title: "E-commerce",
    description: "Same-day delivery support for online sellers.",
    icon: ShoppingCart,
  },
  {
    title: "Bulk Orders",
    description: "Multiple parcel delivery for businesses.",
    icon: Boxes,
  },
];

const trustCards = [
  {
    title: "Fast Pickup",
    description: "Quick pickup from your location on priority.",
    icon: LocateFixed,
  },
  {
    title: "Reliable Riders",
    description: "Verified and trained riders for safe delivery.",
    icon: BadgeCheck,
  },
  {
    title: "Affordable Pricing",
    description: "Best prices with no hidden charges.",
    icon: IndianRupee,
  },
  {
    title: "WhatsApp Support",
    description: "Get support instantly on WhatsApp.",
    icon: MessageCircleMore,
  },
];

const testimonials = [
  {
    name: "Rahul Mehta",
    role: "Business Owner",
    text: "Instaport Delivery is very fast and reliable. I use it for my business parcels every day.",
  },
  {
    name: "Priya Sharma",
    role: "Customer",
    text: "Very good service. My medicines were delivered on time. Highly recommended.",
  },
  {
    name: "Amit Verma",
    role: "E-commerce Seller",
    text: "Bulk order delivery is super smooth. Great support team on WhatsApp.",
  },
];

const footerLinks = {
  instagram: "https://www.instagram.com/instaportdelivery",
  facebook: "https://www.facebook.com/people/instaportdelivery/61590141218960/",
  linkedin: "https://www.linkedin.com/",
  riderApp: "https://play.google.com/store/apps/details?id=com.instaport.rider",
  customerApp:
    "https://play.google.com/store/apps/details?id=com.instaport.customer",
  customerIos:
    "https://apps.apple.com/in/app/instaport-delivery/id6751334012",
};

const benefitChips = [
  "No hidden charges",
  "Same-day delivery",
  "Live tracking",
  "WhatsApp support",
];

const fareDeliveryTypes = [
  {
    value: "now",
    label: "Express",
    helper: "Quick delivery",
    details: "For urgent parcels that need to be delivered as soon as possible.",
  },
  {
    value: "flexible",
    label: "Flexible",
    helper: "Delivery within 4–5 hours",
    details:
      "Flexible Delivery orders can be booked between 8:00 AM and 6:00 PM. Delivery will be completed within 4–5 hours.",
  },
  {
    value: "scheduled",
    label: "Schedule",
    helper: "Schedule your delivery",
    details: "You can schedule your order up to 3 days in advance, from tomorrow.",
  },
];

const addressInitialState = {
  text: "",
  latitude: 0,
  longitude: 0,
};

const readGoogleCoordinate = (location, axis, fallback) => {
  const candidate =
    typeof location?.[axis] === "function"
      ? location[axis]()
      : Number(location?.[axis]);

  return Number.isFinite(candidate) ? candidate : fallback;
};

const BULK_ORDER_WHATSAPP_URL = "https://t.heyo.bot/8atkt4b";

const Home = () => {
  const navigate = useNavigate();
  const [showSigninModal, setShowSigninModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [mobileForOTP, setMobileForOTP] = useState("");
  const [otpIntent, setOtpIntent] = useState(null);
  const [showSessionExpiredPopup, setShowSessionExpiredPopup] = useState(false);
  const [calculationLoading, setCalculationLoading] = useState(false);
  const [isFetchingLocation, setIsFetchingLocation] = useState(false);
  const [estimatedFare, setEstimatedFare] = useState(0);
  const [selectedFareDeliveryType, setSelectedFareDeliveryType] = useState("now");
  const [bookingTime, setBookingTime] = useState(Date.now);
  const isFlexibleBookingOpen = (timestamp) => {
    const hour = new Date(timestamp + 5.5 * 60 * 60 * 1000).getUTCHours();
    return hour >= 8 && hour < 18;
  };
  const flexibleBookingClosed = selectedFareDeliveryType === "flexible" &&
    !isFlexibleBookingOpen(bookingTime);
  const flexibleBookingMessage = "Flexible delivery can only be booked from 8 AM to 6 PM (IST).";

  useEffect(() => {
    if (selectedFareDeliveryType !== "flexible") return undefined;
    const refresh = () => setBookingTime(Date.now());
    // Update at the next opening/closing boundary, including a page left open.
    const now = Date.now();
    const ist = new Date(now + 5.5 * 60 * 60 * 1000);
    const next = new Date(ist);
    const hour = ist.getUTCHours();
    if (hour >= 18) next.setUTCDate(next.getUTCDate() + 1);
    next.setUTCHours(hour >= 8 && hour < 18 ? 18 : 8, 0, 0, 0);
    const timer = window.setTimeout(refresh, next.getTime() - ist.getTime());
    window.addEventListener("focus", refresh);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("focus", refresh);
    };
  }, [selectedFareDeliveryType, bookingTime]);
  const [pickupAddress, setPickupAddress] = useState(addressInitialState);
  const [dropAddress, setDropAddress] = useState(addressInitialState);
  const [showServiceabilityModal, setShowServiceabilityModal] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const fareEstimateRequestRef = useRef(0);

  useEffect(() => {
    verifyToken(setShowSessionExpiredPopup);
  }, []);

  useEffect(() => {
    if (carouselSlides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setCurrentSlideIndex((previousIndex) =>
        (previousIndex + 1) % carouselSlides.length
      );
    }, 4500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const currentSlide = useMemo(
    () => carouselSlides[currentSlideIndex] || carouselSlides[0],
    [currentSlideIndex]
  );
  const titleParts = useMemo(() => {
    const title = currentSlide?.title || "";
    const highlight = currentSlide?.highlight || "";
    if (!highlight || !title.includes(highlight)) {
      return { before: title, highlight: "", after: "" };
    }
    const [before, after = ""] = title.split(highlight);
    return { before: before.trim(), highlight, after: after.trim() };
  }, [currentSlide]);

  const calculateRate = async (deliveryType) => {
    // React supplies the click event to a handler passed directly to onClick.
    // Accept only one of our supported delivery types so an event can never
    // reach Axios as part of the estimate payload.
    const requestedDeliveryType = fareDeliveryTypes.some(
      (option) => option.value === deliveryType
    )
      ? deliveryType
      : selectedFareDeliveryType;

    if (
      !pickupAddress.latitude ||
      !pickupAddress.longitude ||
      !dropAddress.latitude ||
      !dropAddress.longitude
    ) {
      toast.error("Please select pickup and drop locations");
      return;
    }

    const requestId = ++fareEstimateRequestRef.current;
    setCalculationLoading(true);
    try {
      const estimateResponse = await axios.post(`${String(API_URL).trim()}/order/estimate`, {
        locations: [pickupAddress, dropAddress],
        // The home calculator has no parcel-weight or payment selector. Match
        // the customer app's initial quote defaults so both surfaces ask the
        // existing pricing service for the same baseline fare.
        parcel_weight: "0-1 kg",
        // This public calculator displays only the delivery fare. The actual
        // parcel value and security fee are applied later at checkout.
        parcel_value: 1,
        delivery_type: requestedDeliveryType,
        payment_method: "online",
      });
      const estimate = estimateResponse.data || {};
      if (estimate.error || !Number.isFinite(Number(estimate.deliveryCharge))) {
        throw new Error(estimate.message || "Unable to calculate the delivery price.");
      }

      if (requestId !== fareEstimateRequestRef.current) return;
      setEstimatedFare(Math.max(0, Math.round(Number(estimate.deliveryCharge))));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to calculate fare. Please try again.";
      console.error("Failed to calculate fare:", errorMessage);
      if (requestId === fareEstimateRequestRef.current) {
        setEstimatedFare(0);
        toast.error(errorMessage);
      }
    } finally {
      if (requestId === fareEstimateRequestRef.current) {
        setCalculationLoading(false);
      }
    }
  };

  const handleFareDeliveryTypeChange = (deliveryType) => {
    if (deliveryType === selectedFareDeliveryType) return;

    setSelectedFareDeliveryType(deliveryType);
    setBookingTime(Date.now());
    setEstimatedFare(0);

  };

  useEffect(() => {
    fareEstimateRequestRef.current += 1;
    setEstimatedFare(0);
    setCalculationLoading(false);
    if (!pickupAddress.latitude || !pickupAddress.longitude || !dropAddress.latitude || !dropAddress.longitude) return;
    const timer = window.setTimeout(() => calculateRate(), 250);
    return () => window.clearTimeout(timer);
    // Recalculate only when a selected location or delivery type changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickupAddress.latitude, pickupAddress.longitude, dropAddress.latitude, dropAddress.longitude, selectedFareDeliveryType]);

  const handleBookDelivery = async () => {
    if (selectedFareDeliveryType === "flexible" && !isFlexibleBookingOpen(Date.now())) {
      setBookingTime(Date.now());
      toast.info(flexibleBookingMessage);
      return;
    }
    saveBookingDraft({ pickup: pickupAddress, drop: dropAddress, deliveryType: selectedFareDeliveryType });
    const token = localStorage.getItem("token");
    if (!token) {
      setShowSigninModal(true);
      return;
    }
    try {
      await syncSessionUser(token);
      navigate("/create-order");
    } catch (error) {
      if (error.status === 401 || error.status === 403) {
        clearSessionData();
        setShowSigninModal(true);
      } else {
        toast.error("Unable to check your session. Please check your connection and try again.");
      }
    }
  };

  const clearPickupAddress = () => {
    setPickupAddress(addressInitialState);
    setEstimatedFare(0);
  };

  const clearDropAddress = () => {
    setDropAddress(addressInitialState);
    setEstimatedFare(0);
  };

  const handleGetCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.");
      return;
    }

    setIsFetchingLocation(true);
    getPreciseCurrentLocation({
      desiredAccuracy: 80,
      timeoutMs: 12000,
      maximumAge: 0,
    })
      .then(async (position) => {
        const { latitude, longitude } = position.coords;
        const verification = await checkAddressServiceability({ latitude, longitude });
        if (!verification.serviceable) {
          setShowServiceabilityModal(true);
          setIsFetchingLocation(false);
          return;
        }

        const geocoder = window.google?.maps?.Geocoder
          ? new window.google.maps.Geocoder()
          : null;

        if (!geocoder) {
          fareEstimateRequestRef.current += 1;
          setEstimatedFare(0);
          setPickupAddress({
            text: `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`,
            latitude,
            longitude,
          });
          setIsFetchingLocation(false);
          return;
        }

        geocoder.geocode(
          { location: { lat: latitude, lng: longitude } },
          (results, status) => {
            const resolvedAddressResult =
              status === "OK" ? getBestGeocodeResult(results) : null;
            const fullAddress =
              resolvedAddressResult
                ? getCurrentLocationAddressFromGeocodeResults(
                  results,
                  `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`
                )
                : `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
            // Keep the existing current-location flow, but use the resolved
            // Google address coordinate for the quote when available. This
            // prevents an imprecise browser reading from being priced while
            // only its address label is corrected by reverse geocoding.
            const resolvedLatitude = readGoogleCoordinate(
              resolvedAddressResult?.geometry?.location,
              "lat",
              latitude
            );
            const resolvedLongitude = readGoogleCoordinate(
              resolvedAddressResult?.geometry?.location,
              "lng",
              longitude
            );

            setPickupAddress({
              text: fullAddress,
              place_id: resolvedAddressResult?.place_id || "",
              latitude: resolvedLatitude,
              longitude: resolvedLongitude,
            });
            fareEstimateRequestRef.current += 1;
            setEstimatedFare(0);

            if (status !== "OK") {
              toast.info("Location found, but street address was unavailable.");
            }
            setIsFetchingLocation(false);
          }
        );
      })
      .catch((error) => {
        const errorMessage =
          error.code === error.PERMISSION_DENIED
            ? "Please allow location access to use your current pickup."
            : error.code === error.TIMEOUT || /timed out/i.test(error.message || "")
              ? "Getting your location timed out. Please try again."
              : "Your current location could not be found.";

        toast.error(errorMessage);
        setIsFetchingLocation(false);
      });
  };

  const handleLogout = () => {
    clearSessionData();
    setShowSessionExpiredPopup(false);
    toast.success("Logged out successfully", { position: "bottom-center" });
    navigate("/");
  };

  const handleCreateOrderClick = (event) => {
    checkTokenAndNavigate(
      "/create-order",
      navigate,
      setShowSigninModal,
      setShowSessionExpiredPopup,
      () => { },
      event
    );
  };

  return (
    <>
      <ServiceabilityModal
        open={showServiceabilityModal}
        onClose={() => setShowServiceabilityModal(false)}
      />
      <div className="min-h-screen bg-[#f8f4e8] text-slate-900">
        <div className="px-0 pb-1 pt-0">
          <Navbar />
        </div>

        <main className="pb-14">
          <section className="relative overflow-hidden bg-black">


            <img
              src={currentSlide.mobileImage || currentSlide.image}
              alt={currentSlide.title}
              className="absolute inset-0 h-full w-full object-cover transition-all duration-700 md:hidden"
              style={{ objectPosition: currentSlide.mobilePosition || "center center" }}
            />

            <img
              src={currentSlide.image}
              alt={currentSlide.title}
              className="
        absolute
        inset-0
        hidden
        h-full
        w-full
        object-cover
        transition-all
        duration-700
        md:block
      "
              style={{
                objectPosition: currentSlide.position || "center center",
              }}
            />

            <div
              className={`absolute inset-0 ${currentSlide.overlayClassName ||
                "bg-[linear-gradient(90deg,rgba(0,0,0,0.84)_0%,rgba(0,0,0,0.64)_32%,rgba(0,0,0,0.28)_58%,rgba(0,0,0,0.10)_100%)]"
                }`}
            />
            <div
              className={`absolute inset-0 ${currentSlide.accentOverlayClassName ||
                "bg-[radial-gradient(circle_at_top_right,rgba(255,197,55,0.16),rgba(255,197,55,0)_28%),linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.20)_100%)]"
                }`}
            />

            <div
              className={`relative mx-auto flex w-full max-w-[1440px] items-center ${currentSlide.containerClassName ||
                "min-h-[640px] px-4 py-12 sm:px-6 lg:min-h-[720px] lg:px-8"
                }`}
            >
              <div
                className={
                  currentSlide.contentClassName || "max-w-[560px] pt-4 text-white lg:pl-10"
                }
              >
                <div
                  className={`inline-flex ${currentSlide.eyebrowClassName ||
                    "rounded-full bg-[#f1b400] px-4 py-2 text-sm font-bold text-slate-950"
                    }`}
                >
                  {currentSlide.eyebrow}
                </div>
                <h1
                  className={
                    currentSlide.titleClassName ||
                    "mt-5 text-4xl font-extrabold leading-tight sm:text-5xl lg:text-[58px]"
                  }
                >
                  {titleParts.before ? <span className="block">{titleParts.before}</span> : null}
                  {titleParts.highlight ? (
                    <span className="block text-[#f1b400]">{titleParts.highlight}</span>
                  ) : null}
                  {titleParts.after ? <span className="block">{titleParts.after}</span> : null}
                </h1>
                <p
                  className={
                    currentSlide.descriptionClassName ||
                    "mt-4 max-w-[520px] text-base leading-7 text-white/85 sm:text-lg"
                  }
                >
                  {currentSlide.description}
                </p>

                <div
                  className={
                    currentSlide.badgesContainerClassName ||
                    "mt-5 flex flex-wrap gap-3"
                  }
                >
                  {currentSlide.badges.map((badge) => {
                    const isObjectBadge =
                      typeof badge === "object" && badge !== null;

                    const label = isObjectBadge ? badge.label : badge;
                    const BadgeIcon = isObjectBadge ? badge.icon : null;

                    return (
                      <span
                        key={label}
                        className={
                          currentSlide.badgeClassName ||
                          "inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2 text-sm font-medium text-white/90 backdrop-blur-sm"
                        }
                      >
                        {BadgeIcon ? (
                          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#f1b400]/40 bg-[#f1b400]/10 text-[#f1b400]">
                            <BadgeIcon className="h-4 w-4" />
                          </span>
                        ) : (
                          <span className="h-2 w-2 shrink-0 rounded-full bg-[#f1b400]" />
                        )}

                        <span>{label}</span>
                      </span>
                    );
                  })}
                </div>

                <div className="mt-8 flex flex-wrap gap-4 pb-8 sm:pb-10 lg:pb-14">
                  <button
                    type="button"
                    onClick={handleCreateOrderClick}
                    className="inline-flex items-center gap-2 rounded-xl bg-[#f1b400] px-6 py-4 text-sm font-bold text-slate-950 shadow-[0_18px_40px_rgba(241,180,0,0.28)] transition hover:bg-[#e5ab00]"
                  >
                    {currentSlide.primaryButtonText || "Book Delivery Now"}
                    <ArrowRight className="h-4 w-4" />
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const section = document.getElementById("fare-calculator");
                      if (section) {
                        section.scrollIntoView({ behavior: "smooth", block: "start" });
                      }
                    }}
                    className="inline-flex items-center gap-2 rounded-xl border border-[#f1b400] bg-black/35 px-6 py-4 text-sm font-bold text-white backdrop-blur-sm transition hover:bg-black/45"
                  >
                    {currentSlide.secondaryButtonText || "Calculate Fare"}
                  </button>
                </div>
              </div>

            </div>
          </section>

          <section
            id="fare-calculator"
            className="relative z-10 mx-auto -mt-10 w-full max-w-[1320px] px-4 sm:px-6 lg:-mt-14 lg:px-8"
          >
            <div className="rounded-[28px] border border-[#efe6d2] bg-white p-5 shadow-[0_25px_60px_rgba(31,45,61,0.08)] sm:p-8">
              <div className="text-center">
                <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1f6d39]">
                  Instant Estimate
                </p>
                <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-[40px]">
                  Calculate Your Delivery Fare
                </h2>
                <p className="mt-3 text-sm leading-7 text-slate-500 sm:text-base">
                  Get instant fare estimate for your pickup and drop location.
                </p>
                <div
                  className="mx-auto mt-6 grid w-full max-w-4xl grid-cols-3 gap-3 sm:gap-5"
                  role="group"
                  aria-label="Select delivery type for fare estimate"
                >
                  {fareDeliveryTypes.map((option, index) => {
                    const selected = option.value === selectedFareDeliveryType;
                    return (
                      <div key={option.value} className="relative min-w-0">
                        <button
                          type="button"
                          onClick={() => handleFareDeliveryTypeChange(option.value)}
                          aria-pressed={selected}
                          className={`w-full rounded-xl py-3 pl-2 pr-8 text-xs font-bold transition sm:py-3.5 sm:pl-5 sm:pr-10 sm:text-base ${selected
                            ? "bg-[#156a2f] text-white shadow-[0_8px_18px_rgba(21,106,47,0.20)]"
                            : "border border-[#d9e5da] bg-white text-slate-600 hover:border-[#8fc59d] hover:bg-[#f5fbf6] hover:text-[#156a2f]"
                            }`}
                        >
                          {option.label}
                        </button>
                        <button
                          type="button"
                          aria-label={`${option.label} delivery information`}
                          className={`peer absolute right-2 top-1/2 z-20 -translate-y-1/2 rounded-full p-1 transition focus:outline-none focus:ring-2 focus:ring-offset-1 sm:right-3 ${selected
                            ? "text-white/90 hover:bg-white/15 focus:ring-white"
                            : "text-slate-400 hover:bg-slate-100 hover:text-[#156a2f] focus:ring-[#156a2f]"
                            }`}
                        >
                          <Info className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
                        </button>
                        <div
                          role="tooltip"
                          className={`
    pointer-events-none
    absolute
    top-full
    z-30
    mt-2

    w-[min(16rem,calc(100vw-32px))]

    rounded-xl
    border
    border-[#d9e5da]
    bg-white
    p-3
    text-left

    opacity-0
    shadow-xl
    transition-opacity

    peer-hover:opacity-100
    peer-focus:opacity-100

    ${index === 0
                              ? "left-0"
                              : index === fareDeliveryTypes.length - 1
                                ? "right-0"
                                : "left-1/2 -translate-x-1/2"
                            }

    sm:right-0
    sm:left-auto
    sm:translate-x-0
    sm:w-64
  `}
                        >
                          <p className="text-sm font-bold text-slate-900">
                            {option.helper}
                          </p>

                          <p className="mt-1 text-xs leading-5 text-slate-600">
                            {option.details}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="mt-8 grid gap-4 lg:grid-cols-2">
                <div className="rounded-2xl border border-[#ede4ce] p-4 shadow-[0_10px_28px_rgba(15,23,42,0.04)]">
                  <div className="mb-3 flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#fff4d0] text-[#d89b00]">
                      <MapPin className="h-5 w-5" />
                    </span>
                    <div>
                      <p className="text-base font-bold text-slate-900">Pickup Location</p>
                      <p className="text-sm text-slate-500">Enter pickup location</p>
                    </div>
                  </div>

                  <NearbyPlacesAutocomplete
                    id="home-pickup-address"
                    name="home-pickup-location-search"
                    value={pickupAddress.text}
                    onChange={(text) => {
                      fareEstimateRequestRef.current += 1;
                      setEstimatedFare(0);
                      setPickupAddress({ text, latitude: 0, longitude: 0 });
                    }}
                    onSelect={(location) => {
                      setPickupAddress({
                        text: getAddressText(location),
                        address: location.address,
                        place_id: location.placeId,
                        latitude: location.latitude,
                        longitude: location.longitude,
                      });
                      return true;
                    }}
                    onServiceabilityRejected={() => setShowServiceabilityModal(true)}
                    onServiceabilityError={(error) => toast.error(error.message)}
                    debounceMs={200}
                    placeholder="Enter pickup location"
                    containerClassName="relative w-full"
                    className="min-h-[86px] w-full resize-none rounded-2xl border border-[#ece3cf] bg-[#fffdfa] px-4 py-4 pr-20 text-sm leading-6 text-slate-900 outline-none transition focus:border-[#f1b400] sm:pr-24 sm:text-base"
                    dropdownClassName="absolute z-20 mt-2 w-full overflow-hidden rounded-2xl border border-[#efe4cc] bg-white shadow-xl"
                    suggestionClassName="cursor-pointer px-4 py-3 text-sm text-slate-700 hover:bg-[#fff8e7]"
                    activeSuggestionClassName="cursor-pointer bg-[#fff3c8] px-4 py-3 text-sm text-slate-800"
                    multiline
                    rows={2}
                    autoComplete="new-password"
                    rightAdornment={
                      <div className="absolute right-3 top-1/2 flex -translate-y-1/2 flex-col items-center gap-1.5">
                        {pickupAddress.text ? (
                          <button
                            type="button"
                            onClick={clearPickupAddress}
                            className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
                            aria-label="Clear pickup address"
                          >
                            <X className="h-4 w-4" />
                          </button>
                        ) : null}
                        <button
                          type="button"
                          onClick={handleGetCurrentLocation}
                          disabled={isFetchingLocation}
                          className="flex h-10 w-10 items-center justify-center rounded-xl text-[#d89b00] transition hover:bg-[#fff7e1] disabled:opacity-60"
                          aria-label="Use current location"
                        >
                          {isFetchingLocation ? (
                            <LoaderCircle className="h-5 w-5 animate-spin" />
                          ) : (
                            <LocateFixed className="h-5 w-5" />
                          )}
                        </button>
                      </div>
                    }
                  />
                </div>

                <div className="rounded-2xl border border-[#ede4ce] p-4 shadow-[0_10px_28px_rgba(15,23,42,0.04)]">
                  <div className="mb-3 flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#fff4d0] text-[#d89b00]">
                      <MapPin className="h-5 w-5" />
                    </span>
                    <div>
                      <p className="text-base font-bold text-slate-900">Drop Location</p>
                      <p className="text-sm text-slate-500">Enter drop location</p>
                    </div>
                  </div>

                  <NearbyPlacesAutocomplete
                    id="home-drop-address"
                    name="home-drop-location-search"
                    value={dropAddress.text}
                    onChange={(text) => {
                      fareEstimateRequestRef.current += 1;
                      setEstimatedFare(0);
                      setDropAddress({ text, latitude: 0, longitude: 0 });
                    }}
                    onSelect={(location) => {
                      setDropAddress({
                        text: getAddressText(location),
                        address: location.address,
                        place_id: location.placeId,
                        latitude: location.latitude,
                        longitude: location.longitude,
                      });
                      return true;
                    }}
                    onServiceabilityRejected={() => setShowServiceabilityModal(true)}
                    onServiceabilityError={(error) => toast.error(error.message)}
                    debounceMs={200}
                    placeholder="Enter drop location"
                    containerClassName="relative w-full"
                    className="min-h-[86px] w-full resize-none rounded-2xl border border-[#ece3cf] bg-[#fffdfa] px-4 py-4 pr-14 text-sm leading-6 text-slate-900 outline-none transition focus:border-[#f1b400] sm:pr-16 sm:text-base"
                    dropdownClassName="absolute z-20 mt-2 w-full overflow-hidden rounded-2xl border border-[#efe4cc] bg-white shadow-xl"
                    suggestionClassName="cursor-pointer px-4 py-3 text-sm text-slate-700 hover:bg-[#fff8e7]"
                    activeSuggestionClassName="cursor-pointer bg-[#fff3c8] px-4 py-3 text-sm text-slate-800"
                    multiline
                    rows={2}
                    autoComplete="new-password"
                    rightAdornment={
                      dropAddress.text ? (
                        <button
                          type="button"
                          onClick={clearDropAddress}
                          className="absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
                          aria-label="Clear drop address"
                        >
                          <X className="h-4 w-4" />
                        </button>
                      ) : null
                    }
                  />
                </div>
              </div>

              <button
                type="button"
                onClick={() => calculateRate()}
                disabled={calculationLoading}
                className="mt-5 w-full rounded-2xl bg-[#156a2f] px-6 py-4 text-base font-bold text-white shadow-[0_18px_38px_rgba(21,106,47,0.18)] transition hover:bg-[#0f5927] disabled:cursor-not-allowed disabled:opacity-70"
              >
                {calculationLoading ? "Calculating..." : "Calculate Fare"}
              </button>

              <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
                {benefitChips.map((item) => (
                  <span
                    key={item}
                    className="inline-flex items-center gap-2 rounded-full border border-[#e8ddc2] bg-[#fffdf7] px-4 py-2 text-sm font-medium text-slate-700"
                  >
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#e9f6ed] text-[#1f6d39]">
                      <ShieldCheck className="h-3.5 w-3.5" />
                    </span>
                    {item}
                  </span>
                ))}
              </div>

              {estimatedFare > 0 ? (
                <div className="mt-5 text-center">
                  <div className="inline-flex items-center gap-3 rounded-full border border-[#d5f0db] bg-[linear-gradient(180deg,#effff2_0%,#e1f9e7_100%)] px-5 py-3 text-sm font-bold text-[#156a2f] shadow-[0_14px_30px_rgba(21,106,47,0.12)] sm:px-6 sm:py-3.5 sm:text-base">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-[#1c7a36] shadow-[0_6px_14px_rgba(21,106,47,0.10)]">
                      <ShieldCheck className="h-4.5 w-4.5" />
                    </span>
                    <span>Estimated Fare</span>
                    <span className="text-xl font-extrabold sm:text-2xl">
                      {formatCurrency(estimatedFare)}
                    </span>
                  </div>
                  <div><button type="button" onClick={handleBookDelivery} disabled={flexibleBookingClosed} aria-describedby={flexibleBookingClosed ? "flexible-booking-hours" : undefined} className="mt-4 rounded-xl bg-[#156a2f] px-8 py-3 font-bold text-white hover:bg-[#0f5927] disabled:cursor-not-allowed disabled:opacity-50">Book Delivery</button></div>
                  {flexibleBookingClosed && <p id="flexible-booking-hours" role="status" className="mt-3 text-sm text-amber-800">{flexibleBookingMessage}</p>}
                </div>
              ) : null}
            </div>
          </section>

          <section id="services" className="mx-auto w-full max-w-[1320px] px-4 pt-16 sm:px-6 lg:px-8">
            <div className="text-center">
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1f6d39]">
                Our Services
              </p>
              <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-[40px]">
                What We Deliver
              </h2>
            </div>

            <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
              {serviceCards.map(({ title, description, icon: Icon }) => (
                <div
                  key={title}
                  className="rounded-[24px] border border-[#efe7d2] bg-white p-6 text-center shadow-[0_12px_32px_rgba(15,23,42,0.05)] transition hover:-translate-y-1 hover:shadow-[0_18px_38px_rgba(15,23,42,0.08)]"
                >
                  <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#fff4d0] text-[#d89b00]">
                    <Icon className="h-9 w-9" />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-slate-900">{title}</h3>
                  <p className="mt-3 text-sm leading-7 text-slate-500">{description}</p>
                </div>
              ))}
            </div>
          </section>

          <section id="bulk-orders" className="mx-auto w-full max-w-[1320px] px-4 pt-14 sm:px-6 lg:px-8">
            <div className="relative overflow-hidden rounded-[30px] bg-[linear-gradient(90deg,#ffcf2d_0%,#f1b400_52%,#c98500_100%)] shadow-[0_22px_60px_rgba(229,171,0,0.22)]">
              <div className="absolute inset-y-0 right-0 hidden w-[44%] lg:block">
                <img
                  src="/assets/delivery_man_images/homepage1.png"
                  alt="Instaport delivery partner"
                  className="h-full w-full object-contain object-right-bottom"
                  style={{
                    WebkitMaskImage:
                      "linear-gradient(90deg, transparent 0%, rgba(0,0,0,0.20) 14%, rgba(0,0,0,0.88) 28%, #000 100%), linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.75) 12%, #000 32%, #000 100%)",
                    WebkitMaskComposite: "source-in",
                  }}
                />
                <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(241,180,0,0.96)_0%,rgba(241,180,0,0.72)_15%,rgba(241,180,0,0.18)_32%,rgba(241,180,0,0)_48%),linear-gradient(180deg,rgba(255,207,45,0.18)_0%,rgba(255,207,45,0)_14%,rgba(201,133,0,0.12)_100%)]" />
              </div>

              <div className="grid items-center gap-6 p-6 md:p-8 lg:grid-cols-[1.06fr_0.94fr]">
                <div className="relative z-10 max-w-[560px]">
                  <h2 className="text-3xl font-extrabold leading-tight text-slate-950 sm:text-[42px]">
                    Bulk Orders? We Handle It Easily
                  </h2>
                  <p className="mt-4 text-base leading-8 text-slate-900/82">
                    For shops, offices, restaurants and e-commerce sellers -
                    schedule multiple deliveries with simple WhatsApp support.
                  </p>

                  <button
                    type="button"
                    onClick={() =>
                      window.open(BULK_ORDER_WHATSAPP_URL, "_blank", "noopener,noreferrer")
                    }
                    className="mt-6 inline-flex items-center gap-3 rounded-xl bg-[#156a2f] px-5 py-4 text-sm font-bold text-white shadow-[0_16px_36px_rgba(21,106,47,0.24)] transition hover:bg-[#0f5927]"
                  >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#25d366] text-white">
                      <FaWhatsapp className="text-xl" />
                    </span>
                    Send Bulk Order on WhatsApp
                  </button>
                </div>

                <div className="relative flex flex-col justify-between gap-5 lg:pl-6">
                  <div className="absolute inset-y-0 left-[8%] hidden w-[360px] rounded-full bg-[radial-gradient(circle,rgba(255,232,150,0.46)_0%,rgba(255,232,150,0.12)_45%,rgba(255,232,150,0)_72%)] lg:block" />
                  <div className="relative z-10 flex justify-center lg:hidden">
                    <img
                      src="/assets/delivery_man_images/homepage1.png"
                      alt="Instaport delivery partner"
                      className="h-[220px] w-full max-w-[420px] object-contain sm:h-[250px]"
                      style={{
                        WebkitMaskImage:
                          "radial-gradient(circle at center, #000 58%, rgba(0,0,0,0.92) 72%, rgba(0,0,0,0) 100%)",
                      }}
                    />
                  </div>
                  <div className="relative z-10 grid gap-3 text-sm font-semibold text-white sm:grid-cols-2">
                    <div className="rounded-2xl border border-white/15 bg-black/20 px-4 py-3 backdrop-blur-sm">
                      Same-day bulk pickup
                    </div>
                    <div className="rounded-2xl border border-white/15 bg-black/20 px-4 py-3 backdrop-blur-sm">
                      Multiple delivery points
                    </div>
                    <div className="rounded-2xl border border-white/15 bg-black/20 px-4 py-3 backdrop-blur-sm">
                      Secure & on-time delivery
                    </div>
                    <div className="rounded-2xl border border-white/15 bg-black/20 px-4 py-3 backdrop-blur-sm">
                      Dedicated support
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mx-auto w-full max-w-[1320px] px-4 pt-14 sm:px-6 lg:px-8">
            <div className="text-center">
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1f6d39]">
                Why Choose Instaport
              </p>
              <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-[40px]">
                Delivery that you can trust every time
              </h2>
            </div>

            <div className="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
              {trustCards.map(({ title, description, icon: Icon }) => (
                <div
                  key={title}
                  className="rounded-[24px] border border-[#efe7d2] bg-white p-6 shadow-[0_12px_32px_rgba(15,23,42,0.05)]"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#e9f6ed] text-[#1f6d39]">
                      <Icon className="h-7 w-7" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-slate-900">{title}</h3>
                      <p className="mt-2 text-sm leading-7 text-slate-500">{description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="rider-cta" className="mx-auto w-full max-w-[1320px] px-4 pt-14 sm:px-6 lg:px-8">
            <div className="overflow-hidden rounded-[30px] border border-[#efe7d2] bg-white shadow-[0_18px_42px_rgba(15,23,42,0.06)]">
              <div className="grid items-center gap-6 px-6 py-7 md:grid-cols-[0.85fr_1.15fr_0.7fr] md:px-8 lg:px-10">
                <div className="relative flex min-h-[220px] items-center justify-center overflow-hidden rounded-[24px] bg-[radial-gradient(circle_at_30%_20%,rgba(255,220,132,0.22),rgba(255,255,255,0)_36%),linear-gradient(180deg,#fffef9_0%,#fff8ea_100%)] md:justify-start">
                  <img
                    src="/assets/delivery_man_images/homepage2.png"
                    alt="Become a rider"
                    className="h-full w-full object-contain object-center"
                    style={{
                      WebkitMaskImage:
                        "radial-gradient(circle at center, #000 54%, rgba(0,0,0,0.95) 70%, rgba(0,0,0,0) 100%)",
                    }}
                  />
                </div>

                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1f6d39]">
                    Become a Rider
                  </p>
                  <h2 className="mt-3 text-3xl font-extrabold text-[#1f6d39] sm:text-[40px]">
                    Earn with Instaport Delivery
                  </h2>
                  <p className="mt-3 max-w-[540px] text-sm leading-7 text-slate-500 sm:text-base">
                    Flexible work, quick registration and daily earning opportunities.
                  </p>

                  <div className="mt-5 flex flex-wrap gap-4 text-sm font-semibold text-slate-700">
                    <span className="rounded-full bg-[#eef8f0] px-4 py-2">Quick Registration</span>
                    <span className="rounded-full bg-[#eef8f0] px-4 py-2">Flexible Timing</span>
                    <span className="rounded-full bg-[#eef8f0] px-4 py-2">Daily Earnings</span>
                    <span className="rounded-full bg-[#eef8f0] px-4 py-2">Easy App Work</span>
                  </div>
                </div>

                <div className="rounded-[24px] border border-[#efe4c7] bg-[#fffaf0] p-5 text-center">
                  <div className="mx-auto w-fit rounded-2xl border border-[#f0ddb0] bg-white p-3 shadow-sm">
                    <img
                      src="/assets/qrcode3.png"
                      alt="Rider app QR"
                      className="h-32 w-32 object-contain"
                    />
                  </div>
                  <p className="mt-4 text-sm font-semibold text-slate-800">
                    Scan to Download Rider App
                  </p>
                  <div className="mt-4 space-y-3">
                    <a
                      href={footerLinks.riderApp}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <img
                        src="/assets/footer/playstore.png"
                        alt="Google Play"
                        className="mx-auto h-11 w-auto"
                      />
                    </a>
                    {/* <a
                      href={footerLinks.customerIos}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <img
                        src="/assets/footer/appstore.png"
                        alt="App Store"
                        className="mx-auto h-11 w-auto"
                      />
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mx-auto w-full max-w-[1320px] px-4 pt-14 sm:px-6 lg:px-8">
            <div className="text-center">
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#1f6d39]">
                What Our Customers Say
              </p>
              <h2 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-[40px]">
                Trusted by Thousands of Happy Customers
              </h2>
            </div>

            <div className="mt-10 grid gap-4 lg:grid-cols-3">
              {testimonials.map((item) => (
                <div
                  key={item.name}
                  className="rounded-[24px] border border-[#efe7d2] bg-white p-6 shadow-[0_12px_32px_rgba(15,23,42,0.05)]"
                >
                  <p className="text-sm leading-7 text-slate-600">{item.text}</p>
                  <div className="mt-5 flex items-center gap-3">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#fff4d0] text-[#d89b00]">
                      <User className="h-6 w-6" />
                    </div>
                    <div>
                      <p className="font-bold text-slate-900">{item.name}</p>
                      <p className="text-sm text-slate-500">{item.role}</p>
                    </div>
                  </div>
                  <div className="mt-4 flex gap-1 text-[#f1b400]">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <span key={`${item.name}-star-${index}`}>★</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </main>

        <div className="mt-14 overflow-hidden rounded-t-[32px] bg-white shadow-[0_-10px_30px_rgba(177,146,90,0.05)]">
          <Footer />
        </div>
      </div>

      {showSessionExpiredPopup ? (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/55 p-4">
          <div className="w-full max-w-sm rounded-[24px] bg-white p-6 shadow-2xl">
            <h2 className="text-xl font-bold text-slate-900">Session Expired</h2>
            <p className="mt-2 text-sm leading-7 text-slate-500">
              Your session has expired. Please login again.
            </p>
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => {
                  handleLogout();
                  setShowSigninModal(true);
                }}
                className="rounded-xl bg-[#1f6d39] px-5 py-3 text-sm font-semibold text-white"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <Signin
        setOtpIntent={setOtpIntent}
        showSigninModal={showSigninModal}
        setShowSigninModal={setShowSigninModal}
        setShowSignupModal={setShowSignupModal}
        setShowOTPModal={setShowOTPModal}
        setMobileForOTP={setMobileForOTP}
      />

      <Signup
        setOtpIntent={setOtpIntent}
        showSignupModal={showSignupModal}
        setShowSignupModal={setShowSignupModal}
        setShowSigninModal={setShowSigninModal}
        setShowOTPModal={setShowOTPModal}
        setMobileForOTP={setMobileForOTP}
      />

      <OTPVerification
        otpIntent={otpIntent}
        setShowSignupModal={setShowSignupModal}
        showOTPModal={showOTPModal}
        setShowOTPModal={setShowOTPModal}
        setShowSigninModal={setShowSigninModal}
        mobile={mobileForOTP}
      />
    </>
  );
};

export default Home;
